import styled from 'styled-components';

export const TextContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: 1.2rem 0 2.4rem;

  ${({ theme }) => theme.media.laptop`
      padding: 0 0 2.4rem;
  `}
`;

export const Chart = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
export const PieChartWrapper = styled.div`
  padding: 0 6.5rem 3.2rem;
`;

export const ChartChild = styled.div`
  width: 30%;
  margin-bottom: 1.2rem;
`;
export const CommonWrapper = styled.div``;

export const IconListContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 1.6rem;
`;
export const SelectedChartItemDetails = styled.div`
  margin-bottom: 1.2rem;
`;

export const RelativeWrapper = styled.div`
  position: relative;
  width: 100%;

  ${({ theme }) => theme.media.laptop`
      width: unset;
  `}
`;

export const SelectedChartItemDetailsWrapper = styled.div`
  display: none;
  width: 100%;
  position: absolute;
  bottom: -5rem;
  ${({ theme }) => theme.media.laptop`
       display: block;
  `}
`;
